export function Hero({ onStart, t }) {
  return (
    <section className="ssi-hero__wrap" style={heroStyles.wrap}>
      <div className="ssi-hero__left" style={heroStyles.left}>
        <h1 className="ssi-hero__h1" style={heroStyles.h1}>{t.heroTitle}</h1>
        <p style={heroStyles.lede}>{t.heroSub1}</p>
        <p style={heroStyles.lede}>{t.heroSub2}</p>
        <div style={heroStyles.ctas}>
          <a href="#sample" className="btn btn--onDark">{t.heroCta1}</a>
          <a href="#methodology" className="btn" style={heroStyles.ghost}>{t.heroCta2}</a>
        </div>
        <div className="ssi-hero__strip" style={heroStyles.strip}>
          {[
            ['wales','Welsh','flag-wales.png'],
            ['spanish','Spanish','flag-spanish.svg'],
            ['italian','Italian','flag-italian.svg'],
            ['french','French','flag-french.svg'],
            ['japanese','Japanese','flag-japanese.svg'],
            ['chinese','Mandarin','flag-chinese.svg'],
            ['korean','Korean','flag-korean.svg'],
            ['arabic','Arabic','flag-arabic.svg'],
            ['portuguese','Portuguese','flag-portuguese.svg'],
            ['german','German','flag-german.svg'],
          ].map(([f,l,img]) => (
            <div key={f} style={heroStyles.flag}>
              <img src={`/assets/${img}?v=2`} alt="" style={heroStyles.flagImg}/>
              <span>{l}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="ssi-hero__right" style={heroStyles.right}>
        <img className="ssi-hero__img" src="/assets/hero_couple_laughing.png?v=6" alt="" style={heroStyles.heroImg}/>
        <img className="ssi-hero__speech" src="/assets/speech_bubbles_white.png" alt="" style={heroStyles.speech}/>
      </div>
    </section>
  );
}

const heroStyles = {
  wrap: { background:'var(--brandRed)', color:'#fff', padding:'80px 0 72px', position:'relative', overflow:'hidden' },
  left: { maxWidth:600, padding:'0 32px', position:'relative', zIndex:2 },
  h1: { fontFamily:'var(--font-display)', fontSize:64, lineHeight:1.05, color:'#fff', letterSpacing:'-.01em', margin:'0 0 20px', textWrap:'balance' },
  lede: { fontSize:18, lineHeight:1.55, color:'rgba(255,255,255,.92)', margin:'0 0 28px', maxWidth:540 },
  ctas: { display:'flex', gap:12, marginBottom:40 },
  ghost: { background:'transparent', color:'#fff', border:'1px solid rgba(255,255,255,.5)' },
  strip: { display:'flex', gap:22, flexWrap:'wrap', paddingTop:14, borderTop:'1px solid rgba(255,255,255,.2)' },
  flag: { display:'flex', alignItems:'center', gap:8, fontSize:13, color:'rgba(255,255,255,.9)' },
  flagImg: { width:22, height:16, objectFit:'cover', borderRadius:2, boxShadow:'0 0 0 1px rgba(255,255,255,.25)', display:'block' },
  right: { position:'absolute', right:0, top:0, bottom:0, width:'50%', display:'flex', alignItems:'flex-end', justifyContent:'center' },
  heroImg: { width:'100%', height:'100%', objectFit:'cover', objectPosition:'center bottom' },
  speech: { position:'absolute', left:'calc(32% + 60px)', top:10, width:150, height:'auto', opacity:.75, pointerEvents:'none', zIndex:1 },
};
